import React, { useEffect, useState, useRef } from 'react';
import Header from '@custom/Header/Header';
import Barcode from 'react-barcode';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { phoneIcon, mailIcon, mapIcon, printerIcon, mailIconwhite, mapIconWhite, phoneIconWhite, websiteIcon, downloadIcon } from '../../ui/assets/svgIcons/icon';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { _appointmentUrls, _commonUrls } from '@custom/Utils/constants/apiUrls';
import './Preview.css';
import { ConfirmationPopup, Icon, Loader, SuccessModal, Tooltip } from '@ohif/ui';
import { AppDispatch, RootState } from './../store/store';
import { useSelector, useDispatch } from 'react-redux';
import appointmentDetails from '@custom/rtk-apis/appointment/appointmentDetails';
import { calculateAge, capitalizeWords, customStyle, formatDate, formatTime, getCurrencySymbol } from '@custom/Utils/utils';
import { useTheme } from "../../ui/src/contextProviders";
import getPackage from '@custom/rtk-apis/billing/getBilling';
import getInvestigationApi from '@custom/rtk-apis/billing/getInvestigation';
import editInvoiceByIdApi from '@custom/rtk-apis/billing/invoice/editInvoiceById';
import getInvoiceByIdApi from '@custom/rtk-apis/billing/invoice/getInvoiceById';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import axios from 'axios';
import downloadInvoiceApi from '@custom/rtk-apis/billing/invoice/downloadInvoice';
import getBillingGeneralSettings from '@custom/rtk-apis/billing/getGeneralSettings';
import refundLaterApi from '@custom/rtk-apis/billing/invoice/refundLater';
import requestDiscount from '@custom/rtk-apis/billing/discountNotification/requestDiscount';
import { _roleType } from '@custom/Utils/constants/appConstants';

export default function PreviewInvoice() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  let { appointmentId } = useParams();
  const location = useLocation();
  const printRef = useRef<HTMLDivElement>(null);
  const { isDarkMode } = useTheme();
  const [serviceGroups, setServiceGroups] = useState({});
  const [discount, setDiscount] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [note, setNote] = useState('This is a system generated invoice and does not require physical signature');
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [displayMessage, setDisplayMessage] = useState('');
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [confirmationPopup, setConfirmationPopup] = useState({ title: '', message: '' });
  const [orgConfirmationPopup, setOrgConfirmationPopup] = useState({ title: '', message: '' });
  const [isOrgPopupOpen, setIsOrgPopupOpen] = useState(false);
  const [reason, setReason] = useState<string | null>(null);
  const [customReason, setCustomReason] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [paymentMethods, setPaymentMethods] = useState<any[]>([]);
  const [isPaymentPopupOpen, setIsPaymentPopupOpen] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');
  const [refundPaymentMethod, setRefundPaymentMethod] = useState<any>([]);
  const [paymentMethodError, setPaymentMethodError] = useState<any>([]);
  const [htmlContent, setHtmlContent] = useState<string>('');
  const [isDownloading, setIsDownloading] = useState(false);
  const [canceledResponseId, setCanceledResponseId] = useState<string | null>(null);
  const [billingResponseId, setBillingResponseId] = useState<string | null>(null);
  const [currency, setCurrency] = useState('');
  const [storedBillingLogId, setStoredBillingLogId] = useState<string | null>(null);
  const [hasRefetched, setHasRefetched] = useState(false);
  const [hasNavigatedAway, setHasNavigatedAway] = useState(false);
  const [isRefundLaterProcessed, setIsRefundLaterProcessed] = useState(false);
  const [totalCancellableItems, setTotalCancellableItems] = useState(0);
  const [isUrgencyChecked, setIsUrgencyChecked] = useState(false);
  const [discountRequest, setDiscountRequest] = useState({ isRequested: false, details: {} });

  const handleNoteChange = (e: React.FocusEvent<HTMLSpanElement>) => {
    if (isEditMode) {
      setNote(e.target.innerText);
    }
  };

  const handleUrgencyChargeChange = () => {
    const newCheckedState = !isUrgencyChecked;
    setIsUrgencyChecked(newCheckedState);

    if (newCheckedState) {
      setSelectedItems([...selectedItems, 'urgencyCharges']);
    } else {
      setSelectedItems(selectedItems.filter(item => item !== 'urgencyCharges'));
    }
  };

  const isEditMode = location.pathname.includes('/invoice/edit') || location.state?.isEditMode || false;
  const isCancelMode = location.state?.isCancelMode || false;
  const isCopyBillPreview = location.state?.isCopyBillPreview || false;
  const isRefundDetailsOnly = location.state?.isRefundDetailsOnly || false;
  const tableData = location.state?.tableData;

  const { result, loading } = useSelector((state: RootState) => state?.appointmentDetailResponse);
  const { result: invoiceResult, loading: invoiceLoading } = useSelector((state: RootState) => state?.getInvoiceByIdResponse);
  const packageData = useSelector((state: RootState) => state?.getPackageResponse);
  const investigationData = useSelector((state: RootState) => state?.getInvestigationResponse);
  const { msg: editMsg, loading: editLoading, error: editError, result: editResult } = useSelector((state: RootState) => state?.editInvoiceByIdResponse);
  const billingGeneralSettingsData = useSelector((state: RootState) => state.getBillingGeneralSettingsSliceResponse);
  const refundLaterData = useSelector((state: RootState) => state.refundLaterResponse);

  const invoiceStatus = invoiceResult?.type === "INVOICE"
    ? invoiceResult?.invoiceStatus || 'Unpaid'
    : invoiceResult?.type === "CANCELED_INVOICE"
      ? invoiceResult?.canceledBillDetails?.statusOfBill || 'Unpaid'
      : 'Unpaid';


  const checkCanApproveDiscount = () => {
    const userRole = localStorage.getItem('role') || sessionStorage.getItem('role');
    if(userRole === _roleType.admin || userRole === _roleType.superAdmin || userRole === _roleType.hospitalSuperadmin) return true;

    if(userRole === _roleType.frontDesk) {
      const storedApproval  = sessionStorage.getItem('canApproveDiscount') === 'true' || localStorage.getItem('canApproveDiscount') === 'true';
      return storedApproval ;
    }
    return false;
  }

  const fetchCommonData = async () => {
    try {
      const commonData: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.list, body: {}, headerType: 'json' });
      setPaymentMethods(commonData?.result?.paymentMethods || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleRequestDiscountClick = async () => {
    try {
      if (!discount || parseFloat(discount) <= 0) {
        setDisplayMessage('Please enter a valid discount amount');
        setIsSuccessModalOpen(true);
        return;
      }

      if (!invoiceResult?._id) {
        setDisplayMessage('Invoice ID not found');
        setIsSuccessModalOpen(true);
        return;
      }

      // Get user info from storage
      const userName = localStorage.getItem('name') || sessionStorage.getItem('name') || 'Unknown';
      const userId = localStorage.getItem('userId') || sessionStorage.getItem('userId') || 'Unknown';

      const payload = {
        _id: invoiceResult._id,
        requestedByName: userName,
        requestedById: userId,
        amount: parseFloat(discount)
      };

      const response = await dispatch(requestDiscount(payload)).unwrap();

      if (response?.status === 'success') {
        setDisplayMessage(response?.msg || 'Discount request submitted successfully');
        setIsSuccessModalOpen(true);

        // Refresh the invoice data to reflect the changes
        await dispatch(getInvoiceByIdApi({
          id: appointmentId,
          payload: { _id: invoiceResult?._id }
        }));
      } else {
        setDisplayMessage(response?.msg || 'Failed to submit discount request');
        setIsSuccessModalOpen(true);
      }
    } catch (error) {
      console.error('Error requesting discount:', error);
      setDisplayMessage(error?.msg || 'An error occurred while requesting discount');
      setIsSuccessModalOpen(true);
    }
  };

  useEffect(() => {
    if (billingGeneralSettingsData?.result?.currency) {
      setCurrency(billingGeneralSettingsData?.result?.currency);
    }
  }, [billingGeneralSettingsData]);

  useEffect(() => {
    if (printRef.current && invoiceResult) {
      const content = printRef.current.innerHTML;
      setHtmlContent(content);
    }
  }, [invoiceResult, result, isEditMode, isCancelMode, isCopyBillPreview, discount, note, selectedItems]);

  useEffect(() => {
    const totalItems = 
      (invoiceResult?.modality ? 1 : 0) +
      (invoiceResult?.extraModalities?.length || 0) +
      (invoiceResult?.serviceInvestigation?.length || 0);

    let shouldBeChecked = false;
    let shouldBeDisabled = true;

    if (selectedItems.length > 0) {
      shouldBeDisabled = false;
      shouldBeChecked =
        selectedItems.includes('urgencyCharges') ||
        selectedItems.length === totalItems;
    }

    if (selectedItems.length === 0) {
      shouldBeChecked = false;
      shouldBeDisabled = true;
    }

    setIsUrgencyChecked(shouldBeChecked);

    if (shouldBeChecked && !selectedItems.includes('urgencyCharges')) {
      setSelectedItems((prev) => [...prev, 'urgencyCharges']);
    } else if (!shouldBeChecked && selectedItems.includes('urgencyCharges')) {
      setSelectedItems((prev) => prev.filter((item) => item !== 'urgencyCharges'));
    }
  }, [
    invoiceResult?.modality,
    invoiceResult?.extraModalities,
    invoiceResult?.serviceInvestigation,
    selectedItems,
  ]);

  useEffect(() => {
    dispatch(appointmentDetails({ id: invoiceResult?.appointmentId }));
    dispatch(getPackage({}));
    dispatch(getInvestigationApi());
    dispatch(getBillingGeneralSettings());
    dispatch(getInvoiceByIdApi({ id: appointmentId, payload: {} }));
    fetchCommonData();
  }, [invoiceResult?.appointmentId]);

  useEffect(() => {
    if (invoiceResult?.serviceInvestigation && (packageData?.result?.data || investigationData?.result?.data)) {
      const groups: { [key: string]: string[] } = {};
      invoiceResult.serviceInvestigation.forEach((service: string) => {
        const matchingInvestigation = investigationData?.result?.data?.find(
          (investigation: any) => investigation["Package Name"] === service
        );
        const matchingPackage = packageData?.result?.data?.find(
          (pkg: any) => pkg.packageName === service
        );
        if (matchingInvestigation) {
          const packageName = matchingInvestigation["Package Name"];
          const servicesIncluded = matchingInvestigation["Services Included"]?.split(', ') || [];
          groups[packageName] = servicesIncluded;
        } else if (matchingPackage) {
          const packageName = matchingPackage.packageName;
          const servicesIncluded = matchingPackage.servicesIncluded || [];
          groups[packageName] = servicesIncluded;
        } else {
          groups[service] = [];
        }
      });
      if (result?.appointmentType === 'consultation' && invoiceResult?.modality === 'Consultation' &&
        !invoiceResult?.extraModalities?.length && !invoiceResult?.serviceInvestigation?.length) {
        const matchingPackage = packageData?.result?.data?.find((pkg: any) => pkg.packageName === 'Consultation Services');
        const matchingInvestigation = investigationData?.result?.data?.find((inv: any) => inv['Package Name'] === 'Consultation Services');
        const matching = matchingPackage || matchingInvestigation;
        if (matching) {
          const servicesIncluded = matching.servicesIncluded || matching['Services Included']?.split(', ') || [];
          groups['Consultation Services'] = servicesIncluded;
        }
      }
      setServiceGroups(groups);
    }
  }, [invoiceResult, packageData, investigationData]);

  useEffect(() => {


    if (isEditMode && invoiceResult) {
      const initialDisc = invoiceResult.discountedPrice?.toString() || '';
      const initialNt = invoiceResult.note || 'This is a system generated invoice and does not require physical signature';
      window.addEventListener('beforeunload', (e) => {
        e.preventDefault();
        e.returnValue = '';
      });
      const initialSelectedItems = [];
      setInitialDiscount(initialDisc);
      setDiscount(initialDisc);
      setInitialNote(initialNt);
      setNote(initialNt);
      setInitialSelectedItems(initialSelectedItems);
      setSelectedItems(initialSelectedItems);
      if(invoiceResult?.discountRequest){
        setDiscountRequest({ isRequested: true, details: invoiceResult?.discountRequest });
      }
    }
  }, [isEditMode, invoiceResult]);

  useEffect(() => {
    let count = 0;
    if (result?.appointmentType === 'consultation' || (invoiceResult?.modality && invoiceResult?.price)) count++;
    if (invoiceResult?.extraModalities?.length > 0) count += invoiceResult.extraModalities.length;
    if (invoiceResult?.serviceInvestigation?.length > 0) count += invoiceResult.serviceInvestigation.length;
    setTotalCancellableItems(count);
  }, [result?.appointmentType, invoiceResult?.modality, invoiceResult?.price, invoiceResult?.extraModalities, invoiceResult?.serviceInvestigation]);

  const [initialDiscount, setInitialDiscount] = useState('');
  const [initialNote, setInitialNote] = useState('This is a system generated invoice and does not require physical signature');
  const [initialSelectedItems, setInitialSelectedItems] = useState<string[]>([]);
  const statusOfBill = invoiceResult?.canceledBillDetails?.statusOfBill || 'Unpaid';
  const displayStatus = statusOfBill === 'Refund' ? 'Refund (Paid)' : statusOfBill;
  const showRefundDetails = displayStatus === 'Refund (Unpaid)' && statusOfBill === 'Refund (Unpaid)' && invoiceResult?.status === 'CANCELLED';
  const showOnlyRefundDetails = invoiceResult?.invoiceStatus === 'Paid' && invoiceResult?.canceledBillDetails?.statusOfBill === 'Refund' && invoiceResult?.status === 'CANCELLED';
  const showInvoiceCopyDetails = invoiceResult?.invoiceStatus === 'Paid' && invoiceResult?.canceledBillDetails?.statusOfBill === 'Cancelled' && invoiceResult?.status === 'CANCELLED';

  const getPriorityStyle = (priority) => {
    switch (priority) {
      case 'Routine':
        return { border: '1px solid #28a745', color: '#28a745' };
      case 'Priority':
        return { border: '1px solid #007bff', color: '#007bff' };
      case 'Critical':
        return { border: '1px solid #FF5C5C', color: '#FF5C5C' };
      default:
        return { border: '1px solid #ccc', color: '#ccc' };
    }
  };

  const buttonStyle = {
    backgroundColor: 'transparent',
    padding: '5px 15px',
    borderRadius: '4px',
    fontSize: '14px',
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
    ...getPriorityStyle(invoiceResult?.priority),
  };

  const dotStyle = {
    height: '8px',
    width: '8px',
    backgroundColor: buttonStyle.color,
    borderRadius: '50%',
    display: 'inline-block',
    marginRight: '8px',
  };

  const handlePrintPDF = async () => {
    const newWindow = window.open('', '_blank');

    newWindow.document.write(`
      <html>
        <head>
          <title>Preparing Invoice</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              text-align: center;
              padding-top: 100px;
            }
            .loader {
              border: 8px solid #f3f3f3;
              border-top: 8px solid #3498db;
              border-radius: 50%;
              width: 60px;
              height: 60px;
              animation: spin 1s linear infinite;
              margin: 20px auto;
            }
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          </style>
        </head>
        <body>
          <h3>Fetching invoice PDF. Please wait...</h3>
          <div class="loader"></div>
        </body>
      </html>
    `);
    newWindow.document.close();

    try {
      setIsDownloading(true);
      const payload ={ 
        appointmentId: invoiceResult?.appointmentId, 
        invoiceId: invoiceResult?._id 
      }
      
      const response = await dispatch(downloadInvoiceApi(payload));
      if (downloadInvoiceApi.fulfilled.match(response)) {
        const downloadResult = response.payload;

        if (downloadResult?.data?.invoicePdfUrl) {
          const pdfUrl = downloadResult.data.invoicePdfUrl;
          newWindow.location.href = pdfUrl;
        } else {
          newWindow.close();
          alert("PDF URL not found in the response.");
        }
      } else {
        newWindow.close();
        alert("Failed to download invoice. Please try again.");
      }
    } catch (error) {
      newWindow.close();
      alert("An error occurred while opening the invoice PDF.");
    } finally {
      setIsDownloading(false);
    }
  };

  useEffect(() => {
    console.log('firstRender', discount);
  }, [discount]);

  const handleDownloadPDF = async () => {
    try {
      setIsDownloading(true);
      const payload ={ 
        appointmentId: invoiceResult?.appointmentId, 
        invoiceId: invoiceResult?._id 
      }
      const response = await dispatch(downloadInvoiceApi(payload));

      if (downloadInvoiceApi.fulfilled.match(response)) {
        const downloadResult = response.payload;

        if (downloadResult?.data?.invoicePdfUrl) {
          const pdfResponse = await axios({
            url: downloadResult?.data?.invoicePdfUrl,
            method: "GET",
            responseType: "blob",
          });

          const blob = new Blob([pdfResponse.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${invoiceResult?.patientInfo?.firstName}.pdf`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          setTimeout(() => window.URL.revokeObjectURL(url), 100);
        } else {
          console.error("PDF URL not found in response");
        }
      } else {
        console.error("Failed to download invoice:", response.error?.message);
      }
    } catch (error) {
      console.error("Error downloading PDF:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  useEffect(() => {
    if (editResult?.status === 'success') {
      setIsSaving(false);
      if (editResult?.canceledResponse?.id) {
        setCanceledResponseId(editResult.canceledResponse.id);
      }
      if (editResult?.billingLogResponse?.id) {
        setBillingResponseId(editResult?.billingLogResponse?.id);
      }
      if (!['Refund', 'Refund (Unpaid)', 'Paid'].includes(invoiceResult?.canceledBillDetails?.statusOfBill) &&
          !isRefundDetailsOnly &&
          !(tableData?.status === 'Refund (Paid)') && !hasRefetched) {
        setHasRefetched(true);
        dispatch(getInvoiceByIdApi({ id: appointmentId, payload: { _id: invoiceResult?._id } }));
      }
      if (isCancelMode) setSelectedItems([]);
    } else if (editError && !editLoading) {
      setIsSaving(false);
      setHasRefetched(false);
    }
  }, [editMsg, editLoading, editError, editResult, appointmentId, isCancelMode, isRefundDetailsOnly, dispatch, tableData?.status, invoiceResult?.canceledBillDetails?.statusOfBill]);

  useEffect(() => {
    return () => {
      setHasRefetched(false);
      setCanceledResponseId(null);
    };
  }, [appointmentId]);

  const handlePayBack = (index) => {
    navigate('/invoice');
  };

  const handleBack = async (index?: number) => {
    if (invoiceResult?._id && (isCancelMode || isEditMode)) {
      try {
        const payload = {
          invoiceId: invoiceResult._id,
          refundLater: true,
        };
        const response = await dispatch(refundLaterApi(payload)).unwrap();
        if (response?.message === 'Refund status updated' && response?.result?.ok) {
          setIsRefundLaterProcessed(true);
          await dispatch(getInvoiceByIdApi({ id: appointmentId, payload: { _id: invoiceResult?._id } })).unwrap();
        }
      } catch (error) {
        console.error('Error calling refundLaterApi:', error);
        setDisplayMessage('Failed to process Refund Later. Please try again.');
        setIsSuccessModalOpen(true);
      }
    }
    setHasNavigatedAway(true);
    if (location.pathname === '/invoice/preview/') {
      navigate(-1);
    } else {
      navigate('/invoice');
    }
  };

  const handleSaveClick = async () => {
    if (isCancelMode && selectedItems.length > 0) {
      let itemsToDelete: string[] = [];
      if (selectedItems.includes('main')) itemsToDelete.push(capitalizeWords(invoiceResult?.modality || 'Main Modality'));
      invoiceResult?.extraModalities?.forEach((extra: any, index: number) => {
        if (selectedItems.includes(`extra-${index}`)) itemsToDelete.push(capitalizeWords(extra.modality));
      });
      invoiceResult?.serviceInvestigation?.forEach((investigation: string, index: number) => {
        if (selectedItems.includes(`investigation-${index}`)) itemsToDelete.push(capitalizeWords(investigation));
      });

      setConfirmationPopup({
        title: '',
        message: `Are you sure you want to cancel "${itemsToDelete.join(', ')}"?`,
      });
      setIsPopupOpen(true);
    } else {
      if (!invoiceResult?.paymentMethod || invoiceResult.paymentMethod === '') {
        setIsPaymentPopupOpen(true);
      } else {
        await handleSave('Paid');
      }
    }
  };

  const handleSaveOrgClick = () => {
    setOrgConfirmationPopup({
      title: 'Would you like to save changes to this invoice?',
      message: '',
    });
    setIsOrgPopupOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (isPopupOpen) {
      if (!reason && isCancelMode) {
        setErrorMessage('Reason is required.');
        return;
      }
      setErrorMessage('');
      await handleSave('Paid');
      setIsPopupOpen(false);
      if (isCancelMode) setSelectedItems([]);
      await dispatch(getInvoiceByIdApi({
        id: appointmentId,
        payload: { _id: invoiceResult?._id },
      })).unwrap();
    }

    if (isOrgPopupOpen) {
      await handleSave('Subsidy');
      setIsOrgPopupOpen(false);
      await dispatch(getInvoiceByIdApi({
        id: appointmentId,
        payload: { _id: invoiceResult?._id },
      })).unwrap();
    }
  };

  const handleCancelDelete = () => {
    if (isPopupOpen) {
      setIsPopupOpen(false);
      setReason(null);
      setCustomReason('');
      setErrorMessage('');
    }
    if (isOrgPopupOpen) {
      setIsOrgPopupOpen(false);
    }
  };

  const handlePaymentPopupClose = () => {
    setIsPaymentPopupOpen(false);
    setSelectedPaymentMethod('');
  };

  const handlePaymentMethodChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedPaymentMethod(e.target.value);
  };

  const handleMakePayment = () => {
    if (selectedPaymentMethod) {
      handleSave('Paid', selectedPaymentMethod);
      setIsPaymentPopupOpen(false);
      setSelectedPaymentMethod('');
    }
  };

  const handleRefundPayment = async (index: number) => {
    if (refundPaymentMethod[index]) {
      const canceledInvoiceId = invoiceResult?.canceledBillItems?.[0]?.[index]?.canceledInvoiceId;
      await handleSave('Refund', refundPaymentMethod[index], canceledInvoiceId, storedBillingLogId);
      navigate('/invoice');
    } else {
      const newErrors = [...paymentMethodError];
      newErrors[index] = 'Mode of Payment is required';
      setPaymentMethodError(newErrors);
    }
  };

  const handleSave = async (
    status: 'Paid' | 'Refund' | 'Refund (Unpaid)' | 'Subsidy',
    paymentMethod: string | null = null,
    canceledInvoiceId: string | null = null,
    billingLogId: string | null = null
  ) => {
    if (!invoiceResult?.appointmentId) {
      setDisplayMessage('No appointment ID provided. Please try again.');
      setIsSuccessModalOpen(true);
      return;
    }

    if (!invoiceResult) {
      setDisplayMessage('Invoice data not loaded. Please try again.');
      setIsSuccessModalOpen(true);
      return;
    }
    let idToUse = invoiceResult?._id;
    if (
      (status === 'Refund (Unpaid)' && invoiceResult.type === 'CANCELED_INVOICE') ||
      (invoiceResult?.canceledBillDetails?.statusOfBill === 'Refund (Unpaid)' && invoiceResult.type === 'CANCELLED_INVOICE')
    ) {
      idToUse = invoiceResult?._id;
    } else if (status === 'Refund' && invoiceResult.type === 'INVOICE' && canceledInvoiceId) {
      idToUse = canceledInvoiceId;
    }

    const payload = isEditMode && !isCancelMode
      ? {
          discountedPrice: parseFloat(discount) || 0,
          note: note,
          statusOfBill: status,
          reasonOfCancel: customReason ? `${reason}: ${customReason}` : reason,
          ...(paymentMethod && { modeOfPayment: paymentMethod }),
          ...(!paymentMethod && invoiceResult?.paymentMethod && { modeOfPayment: invoiceResult.paymentMethod }),
          invoiceStatus: status === 'Subsidy' ? 'Subsidy' : 'Paid',
        }
      : {
          modeOfRefund: paymentMethod || invoiceResult?.paymentMethod,
          canceledBillItems:
            status === 'Refund' && !isCancelMode
              ? invoiceResult?.currentCanceledBillItems?.[0]?.items || []
              : invoiceResult?.canceledBillItems?.flatMap(group => group.map(item => item.items)).flat() || [],
          cancelItems: [],
          statusOfBill: status,
          reasonOfCancel: customReason ? `${reason}: ${customReason}` : reason,
          canceledId: invoiceResult?._id,
          ...(status === 'Refund' && tableData?.status !== 'Refund (Unpaid)' && { billingLogId: billingResponseId }),
          ...(isUrgencyChecked && { removeUrgencyCharges: invoiceResult.caseStudyPrice || 0 }),
        };
      if (isCancelMode) {
        const canceledBillItems: any[] = [];
        const cancelItems: any[] = [];
        if (selectedItems.includes('main') && invoiceResult?.modality) {
          canceledBillItems.push({
            key: 'modality',
            name: invoiceResult.modality,
            price: invoiceResult.price || 0,
            studyRegion: invoiceResult.studyRegion || '',
          });
          cancelItems.push({
            key: 'modality',
            value: invoiceResult.modality,
          });
        }
        invoiceResult?.extraModalities?.forEach((extra: any, index: number) => {
          if (selectedItems.includes(`extra-${index}`)) {
            canceledBillItems.push({
              key: 'modality',
              name: extra.modality,
              price: extra.price || 0,
              studyRegion: extra.studyRegion || '',
            });
            cancelItems.push({
              key: 'extraModalities',
              value: [
                {
                  modality: extra.modality,
                  studyRegion: extra.studyRegion || '',
                  price: extra.price || 0,
                  appointmentDate: extra.appointmentDate || '',
                  appointmentTime: extra.appointmentTime || '',
                },
              ],
            });
          }
        });
        invoiceResult?.serviceInvestigation?.forEach((investigation: string, index: number) => {
          if (selectedItems.includes(`investigation-${index}`)) {
            const prices = invoiceResult?.investigationPrice
              ? invoiceResult.investigationPrice.split(',').map((price: string) => price.trim())
              : [];
            const price = parseFloat(prices[index]) || 0;
            canceledBillItems.push({
              key: 'serviceInvestigation',
              name: investigation,
              price: price,
              serviceIncluded: serviceGroups[investigation] || [],
            });
            cancelItems.push({
              key: 'serviceInvestigation',
              value: investigation,
              serviceIncluded: serviceGroups[investigation] || [],
            });
          }
        });
        payload.canceledBillItems = canceledBillItems;
        payload.cancelItems = cancelItems;
      }

    try {
      setIsSaving(true);
      const response = await dispatch(editInvoiceByIdApi({
        body: payload,
        id: idToUse,
      })).unwrap();

      if (response?.canceledResponse?.id) {
        setCanceledResponseId(response.canceledResponse.id);
      }

      if (response?.billingLogResponse?.id) {
        setStoredBillingLogId(response?.billingLogResponse?.id);
      }

      await dispatch(getInvoiceByIdApi({
        id: appointmentId,
        payload: { _id: invoiceResult?._id },
      })).unwrap();

      setDisplayMessage(
        isCancelMode && selectedItems.length > 0
          ? 'Items canceled successfully.'
          : 'Payment done successfully.'
      );
      setIsSuccessModalOpen(true);
      setReason(null);
      setCustomReason('');
    } catch (error) {
      console.error('Error saving invoice:', error);
      setDisplayMessage('Error saving invoice. Please try again.');
      setIsSuccessModalOpen(true);
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    setRefundPaymentMethod(new Array(invoiceResult?.canceledBillItems?.length || 1).fill(''));
    setPaymentMethodError(new Array(invoiceResult?.canceledBillItems?.length || 1).fill(''));
  }, [invoiceResult?.canceledBillItems]);

  const handleSuccessMessage = () => {
    setIsSuccessModalOpen(false);
  };

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return '--';
    const date = new Date(timestamp);
    return `${formatDate(date)} ${formatTime(date)}`;
  };

  const checkRequestBtnDisabled = () => {
    const flag = (!discount || discountRequest?.isRequested);
    if(checkCanApproveDiscount()) {
      return true;
    }
    return flag;
  }

  const cancellationReasons = [
    "Selected by mistake",
    "Patient unavailable",
    "Service not required",
    "Other"
  ];

  const shouldDisplayDescriptionTable = !(
    (invoiceResult?.modality === '' || !invoiceResult?.modality) &&
    invoiceResult?.extraModalities?.length === 0 &&
    invoiceResult?.serviceInvestigation?.length === 0
  );

  return (
    <div>
      <Header
        title={
          isCancelMode ? 'Cancel Invoice' :
          invoiceResult?.paymentMethod && isEditMode && invoiceResult?.modeOfPayment ? 'Invoice Preview' :
          invoiceResult?.invoiceStatus === 'Subsidy' && isEditMode ? 'Invoice Preview' :
          !invoiceResult?.paymentMethod && isEditMode && !invoiceResult?.modeOfPayment ? 'Edit Invoice' :
              isCopyBillPreview ? 'Copy of Invoice' :
                isRefundDetailsOnly ? 'Refund Invoice' : 'Invoice Preview'
        }
        isBack={true}
        handleIsBackFunctionality={handleBack}
      />

      <section className='bg-white flex items-center justify-between px-4 pt-4'>
        <div></div>
        <div className='flex flex-row items-center gap-2'>
          <>
            <button
              onClick={handleDownloadPDF}
              className={`bg-green-500 ${isDarkMode ? "text-white" : "text-black"} px-2 py-1 rounded border border-black flex gap-2 items-center text-[14px] font-semibold`}
            >
              <img src={downloadIcon} style={isDarkMode ? null : { filter: "invert(1)" }} />
              Download
            </button>
            <button
              onClick={handlePrintPDF}
              className={`bg-green-500 ${isDarkMode ? "text-white" : "text-black"} px-2 py-1 rounded border border-black flex gap-2 items-center text-[14px] font-semibold`}
            >
              <img src={printerIcon} alt="Print" style={isDarkMode ? { filter: "invert(1)" } : null} />
              Print
            </button>
          </>
        </div>
      </section>

      <div ref={printRef} className='watermark-container' style={{ overflowX: 'auto' }}>
        <div className="bg-white px-4 content" style={{ minWidth: '1200px', color: '#49475A' }}>
          <section className="flex flex-row p-2">
            <div className="basic-1/3 p-4">
              <div className="h-full">
                <div className='flex flex-row h-full w-full'>
                  <div className="block mx-auto" style={{ width: '150px', maxHeight: '150px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: '0 0 150px' }}>
                    {result?.hospitalDetail?.hospitalLogo ? (
                      <img src={result?.hospitalDetail?.hospitalLogo} style={{ height: '100%' }} alt="Hospital Logo" />
                    ) : (
                      <Icon name="DummyLogo" />
                    )}
                  </div>
                  <div className={`border-l-2 ${isDarkMode ? 'border-white' : 'border-[#0F8491]'} ml-4 h-full`}></div>
                </div>
              </div>
            </div>
            <div className="basic-2/3 p-4 w-full ml-4">
              <div>
                <p className={`text-[#0F8491] text-3xl font-semibold ${isDarkMode ? 'text-white' : ''}`}>
                  {result?.hospitalDetail?.hospitalHeader?.hospitalName
                    ? capitalizeWords(result?.hospitalDetail?.hospitalHeader?.hospitalName)
                    : capitalizeWords(result?.hospitalDetail?.hospitalName)}
                </p>
                <ul className="">
                  {result?.hospitalDetail?.specialitites?.map((item: string, index: number) => (
                    <li className={`text-[14px] ${isDarkMode ? "text-white" : "text-[#49475A]"} relative pl-4`} key={index}>
                      <span className={`absolute left-0 top-1 ${isDarkMode ? "text-white" : "text-black"}`}>•</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <div className={`flex flex-row gap-4 border-t-2 ${isDarkMode ? 'border-white' : 'border-[#0F8491]'} pt-2 mt-2`}>
                <div className='flex flex-row gap-2'>
                  <img src={isDarkMode ? phoneIconWhite : phoneIcon} alt="" />
                  <p className={`text-[14px] font-normal ${isDarkMode ? "text-white" : "color-[#535353]"}`}>
                    {result?.hospitalDetail?.hospitalHeader?.contactNumberCountryCode || result?.hospitalDetail?.contactNumberCountryCode}{' '}
                    {result?.hospitalDetail?.hospitalHeader?.contactNumber || result?.hospitalDetail?.contactNumber}
                  </p>
                </div>
                <div className='flex flex-row gap-2'>
                  <img src={isDarkMode ? mailIconwhite : mailIcon} alt="" />
                  <p className={`text-[14px] font-normal ${isDarkMode ? "text-white" : "color-[#535353]"}`}>
                    {result?.hospitalDetail?.hospitalHeader?.email || result?.hospitalDetail?.hospitalEmailId}
                  </p>
                </div>
                <div className='flex flex-row gap-2'>
                  <img src={isDarkMode ? mapIconWhite : mapIcon} alt="" />
                  <p className={`text-[14px] font-normal ${isDarkMode ? "text-white" : "color-[#535353]"}`}>
                    {result?.hospitalDetail?.hospitalHeader?.address
                      ? `${result?.hospitalDetail?.hospitalHeader?.address} ${result?.hospitalDetail?.hospitalHeader?.state} ${result?.hospitalDetail?.hospitalHeader?.city} ${result?.hospitalDetail?.hospitalHeader?.zipCode}`
                      : `${result?.hospitalDetail?.address} ${result?.hospitalDetail?.state} ${result?.hospitalDetail?.city} ${result?.hospitalDetail?.zipCode}`}
                  </p>
                </div>
                {(result?.hospitalDetail?.hospitalHeader?.website || result?.hospitalDetail?.website) && (
                  <div className='flex flex-row gap-2'>
                    <img src={websiteIcon} alt="" />
                    <p className={`text-[14px] font-normal ${isDarkMode ? "text-white" : "color-[#535353]"}`}>
                      {result?.hospitalDetail?.hospitalHeader?.website || result?.hospitalDetail?.website}
                    </p>
                  </div>
                )}
                {invoiceResult?.generalSettings?.gstNo && (
                  <div className='flex flex-row gap-2'>
                    <p className={`text-[14px] font-normal ${isDarkMode ? "text-white" : "color-[#535353]"}`}>
                      <strong>GSTIN:</strong> {invoiceResult?.generalSettings?.gstNo}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </section>

          <section className='bg-[#0F8491] p-2'>
            <p className='text-[17.53px] font-semibold text-white text-center'>Invoice</p>
          </section>

          <section>
            <div className="patient-info-container flex justify-between">
              <div className="patient-details">
                <p className={`text-[17.53px] font-semibold mt-3 ml-2 ${isDarkMode ? 'text-white' : 'text-black'}`}>Invoice to :</p>
                <table className="info-table mt-5">
                  <tbody>
                    <tr>
                      <td className="info-label" valign="top">Patient Name :</td>
                      <td className="info-data" valign="top">{invoiceResult?.patientInfo?.firstName ? `${capitalizeWords(invoiceResult?.patientInfo?.firstName)} ${capitalizeWords(invoiceResult?.patientInfo?.lastName)}` : '--'}</td>
                      <td className="info-label" valign="top">Patient ID :</td>
                      <td className="info-data" valign="top">{invoiceResult?.patientInfo?.patientId || '--'}</td>
                      <td className="info-label" valign="top">Consulting Doctor :</td>
                      <td className="info-data" valign="top">{result?.doctorName || '--'}</td>
                    </tr>
                    <tr>
                      <td className="info-label" valign="top">Age :</td>
                      <td className="info-data" valign="top">{calculateAge(invoiceResult?.patientInfo?.dob) || '--'}</td>
                      <td className="info-label" valign="top">Gender :</td>
                      <td className="info-data" valign="top">{invoiceResult?.patientInfo?.gender || '--'}</td>
                      <td className="info-label" valign="top">Invoice Number :</td>
                      <td className="info-data" valign="top">{invoiceResult?.invoiceNumber?.replace(/-/g, '') || '--'}</td>
                    </tr>
                    <tr>
                      <td className="info-label" valign="top">Phone Number :</td>
                      <td className="info-data" valign="top">{invoiceResult?.patientInfo?.contactInfo?.mobileNo ? `${invoiceResult?.patientInfo?.contactInfo?.dialCode || ''} ${invoiceResult?.patientInfo?.contactInfo?.mobileNo}` : '--'}</td>
                      <td className="info-label" valign="top">Whatsapp Number :</td>
                      <td className="info-data" valign="top">{invoiceResult?.patientInfo?.contactInfo?.whatsappNo ? `${invoiceResult?.patientInfo?.contactInfo?.whatsappNoDialCode || ''} ${invoiceResult?.patientInfo?.contactInfo?.whatsappNo}` : '--'}</td>
                      <td className="info-label" valign="top">Payment Method :</td>
                      <td className="info-data" valign="top">
                        {invoiceResult?.modeOfPayment
                          ? invoiceResult.modeOfPayment === "PayTM" || invoiceResult.modeOfPayment === "Pay TM"
                            ? "PayTM"
                            : invoiceResult.modeOfPayment.replace(/([a-z])([A-Z])/g, '$1 $2')
                          : '--'}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="text-right" style={{ marginTop: '-12px' }}>
                <table className="info-table" style={{ marginTop: '-12px' }}>
                  <tbody>
                    <tr>
                      <td className='info-label'></td>
                      <td className='info-data'>
                        {invoiceResult?.patientInfo?.UHID && (
                          <div className="barcode-section mt-2">
                            <Barcode displayValue={false} width={1} height={40} value={invoiceResult?.patientInfo?.UHID} />
                          </div>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="info-label" valign="top">UHID :</td>
                      <td className="info-data" valign="top">{invoiceResult?.patientInfo?.UHID || '--'}</td>
                    </tr>
                    <tr>
                      <td className="info-label" valign="top">Date :</td>
                      <td className="info-data" valign="top">{result?.date ? formatDate(result?.date) : '--'}</td>
                    </tr>
                    <tr>
                      <td className="info-label" valign="top">Time :</td>
                      <td className="info-data" valign="top">{formatTime(invoiceResult?.createdAt) || '--'}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>

          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
            <button style={buttonStyle}>
              <span style={dotStyle}></span>
              {invoiceResult?.priority}
            </button>
          </div>

          {isCopyBillPreview && (
            <>
              <section className="mt-4 mb-4">
                <h2 className={`text-[17.53px] font-semibold mb-2 ${isDarkMode ? 'text-white' : 'text-black'}`}>Bill Status Details</h2>
                <table className={`w-full border-collapse ${isDarkMode ? 'border-white' : 'border-black'}`}>
                  <tbody>
                    <tr>
                      <td className={`border ${isDarkMode ? 'border-white text-white' : 'border-black'} p-2 text-[14px] font-semibold`}>Created On:</td>
                      <td className={`border ${isDarkMode ? 'border-white text-white' : 'border-black'} p-2 text-[14px]`}>{formatTimestamp(invoiceResult?.createdAt)}</td>
                    </tr>
                    <tr>
                      <td className={`border ${isDarkMode ? 'border-white text-white' : 'border-black'} p-2 text-[14px] font-semibold`}>Paid On:</td>
                      <td className={`border ${isDarkMode ? 'border-white text-white' : 'border-black'} p-2 text-[14px]`}>
                        {formatTimestamp(invoiceResult?.paidAt)}
                      </td>
                    </tr>
                    <tr>
                      <td className={`border ${isDarkMode ? 'border-white text-white' : 'border-black'} p-2 text-[14px] font-semibold`}>Refunded On:</td>
                      <td className={`border ${isDarkMode ? 'border-white text-white' : 'border-black'} p-2 text-[14px]`}>
                        {invoiceResult?.canceledBillDetails?.statusOfBill === 'Refund'
                          ? formatTimestamp(invoiceResult?.canceledBillDetails?.updatedAt || invoiceResult?.updatedAt)
                          : '--'}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </>
          )}

          <section className="relative">
            {(() => {
              if (showRefundDetails || showOnlyRefundDetails) {
                return null;
              }

              return (
                <>
                  {shouldDisplayDescriptionTable && !(invoiceResult?.subTotalAfterCancelation === 0 && invoiceResult?.canceledBillItems?.length > 0) && (
                    <table className={`w-full border-collapse ${isDarkMode ? 'border-white' : 'border-black'}`}>
                      <thead>
                        <tr className="bg-gray-200 text-black">
                          <th className="border-l border-t border-r border-b border-black p-2 text-left">Description</th>
                          <th className="border-t border-r border-b border-black p-2 text-right" style={{ width: '8%' }}>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {invoiceResult?.appointmentType === 'consultation' ? (
                          <tr>
                            <td className={`border-l border-b border-r ${isDarkMode ? 'border-white text-white' : 'border-black'} p-2 text-[14px]`}>
                              <div className="flex items-center">
                                {isCancelMode && (
                                  <input
                                    type="checkbox"
                                    className="mr-2"
                                    style={{ width: '2%' }}
                                    checked={selectedItems.includes('main')}
                                    onChange={() => {
                                      setSelectedItems(prev =>
                                        prev.includes('main')
                                          ? prev.filter(item => item !== 'main')
                                          : [...prev, 'main']
                                      );
                                    }}
                                  />
                                )}
                                <span>
                                  <strong>Consultation Services</strong>
                                </span>
                              </div>
                            </td>
                            <td className={`border-r border-b ${isDarkMode ? 'border-white text-white' : 'border-black'} p-2 text-right text-[14px]`} style={{ width: '8%' }}>
                              {getCurrencySymbol(currency)}{invoiceResult?.price || '--'}
                            </td>
                          </tr>
                        ) : (
                          <>
                            {invoiceResult?.modality && (
                              <tr>
                                <td className={`border-l border-r ${isDarkMode ? 'border-white text-white' : 'border-black'} p-2 text-[14px]`}>
                                  <div className="flex items-center">
                                    {isCancelMode && (
                                      <input
                                        type="checkbox"
                                        className="mr-2"
                                        style={{ width: '2%' }}
                                        checked={selectedItems.includes('main')}
                                        onChange={() => {
                                          setSelectedItems(prev =>
                                            prev.includes('main')
                                              ? prev.filter(item => item !== 'main')
                                              : [...prev, 'main']
                                          );
                                        }}
                                      />
                                    )}
                                    <span>
                                      <strong>{capitalizeWords(invoiceResult.modality)}</strong>
                                      {invoiceResult?.studyRegion && ` - ${invoiceResult.studyRegion}`}
                                    </span>
                                  </div>
                                </td>
                                <td className={`border-r ${isDarkMode ? 'border-white text-white' : 'border-black'} p-2 text-right text-[14px]`} style={{ width: '8%' }}>
                                  {getCurrencySymbol(currency)}{invoiceResult.price}
                                </td>
                              </tr>
                            )}

                            {invoiceResult?.extraModalities?.length > 0 &&
                              invoiceResult.extraModalities.map((extra: any, index: number) => (
                                <tr key={`extra-${index}`}>
                                  <td className={`border-l border-t border-r ${isDarkMode ? 'border-white text-white' : 'border-black'} p-2 text-[14px]`}>
                                    <div className="flex items-center">
                                      {isCancelMode && (
                                        <input
                                          type="checkbox"
                                          className="mr-2"
                                          style={{ width: '2%' }}
                                          checked={selectedItems.includes(`extra-${index}`)}
                                          onChange={() => {
                                            setSelectedItems(prev =>
                                              prev.includes(`extra-${index}`)
                                                ? prev.filter(item => item !== `extra-${index}`)
                                                : [...prev, `extra-${index}`]
                                            );
                                          }}
                                        />
                                      )}
                                      <span>
                                        <strong>{capitalizeWords(extra.modality)}</strong>
                                        {extra.studyRegion && ` - ${extra.studyRegion}`}
                                      </span>
                                    </div>
                                  </td>
                                  <td className={`border-r border-t ${isDarkMode ? 'border-white text-white' : 'border-black'} p-2 text-right text-[14px]`} style={{ width: '8%' }}>
                                    {getCurrencySymbol(currency)}{extra.price}
                                  </td>
                                </tr>
                              ))}

                            {invoiceResult?.serviceInvestigation?.length > 0 && (
                              <>
                                {invoiceResult.serviceInvestigation.map((investigation: string, index: number) => {
                                  const prices = invoiceResult?.investigationPrice
                                    ? invoiceResult.investigationPrice.split(',').map((price: string) => price.trim())
                                    : [];
                                  const price = prices[index] || '--';

                                  return (
                                    <React.Fragment key={`investigation-${index}`}>
                                      <tr>
                                        <td className={`border-l border-t border-r ${isDarkMode ? 'border-white text-white' : 'border-black'} p-2 text-[14px] font-medium`}>
                                          <div className="flex items-center">
                                            {isCancelMode && (
                                              <input
                                                type="checkbox"
                                                className="mr-2"
                                                style={{ width: '2%' }}
                                                checked={selectedItems.includes(`investigation-${index}`)}
                                                onChange={() => {
                                                  setSelectedItems(prev =>
                                                    prev.includes(`investigation-${index}`)
                                                      ? prev.filter(item => item !== `investigation-${index}`)
                                                      : [...prev, `investigation-${index}`]
                                                  );
                                                }}
                                              />
                                            )}
                                            <span>
                                              <strong>{capitalizeWords(investigation)}</strong>
                                            </span>
                                          </div>
                                        </td>
                                        <td className={`border-t border-r ${isDarkMode ? 'border-white text-white' : 'border-black'} p-2 text-right text-[14px]`} style={{ width: '8%' }}>
                                          {getCurrencySymbol(currency)}{price}
                                        </td>
                                      </tr>

                                      {serviceGroups[investigation] &&
                                        serviceGroups[investigation].length > 0 &&
                                        serviceGroups[investigation].map((service: string, serviceIndex: number) => (
                                          <tr key={`service-${investigation}-${serviceIndex}`}>
                                            <td className={`border-l border-r ${isDarkMode ? 'border-white text-white' : 'border-black'} p-1 text-[14px] pl-6`}>
                                              - {capitalizeWords(service)}
                                            </td>
                                            <td className={`border-r ${isDarkMode ? 'border-white' : 'border-black'} p-1 text-right text-[14px]`} style={{ width: '8%' }}></td>
                                          </tr>
                                        ))}
                                    </React.Fragment>
                                  );
                                })}
                          </>
                        )}

                      </>
                    )}
                        {!invoiceResult?.removeUrgencyCharges && invoiceResult?.caseStudyPrice > 0 && (
                          <tr>
                            <td className={`border-l border-t border-r ${isDarkMode ? 'border-white text-white' : 'border-black'} p-1 text-[#0F8491] text-right text-[14px] font-semibold ${isDarkMode ? 'text-white' : ''}`}
                            >
                              {isCancelMode && (
                                <input
                                  type="checkbox"
                                  className="mr-2"
                                  checked={isUrgencyChecked}
                                  onChange={handleUrgencyChargeChange}
                                  disabled={selectedItems.length === 0}
                                />
                              )}
                              Urgency Charges
                            </td>
                            <td className={`border-r border-t ${isDarkMode ? 'border-white text-white' : 'border-black'} p-1 text-right text-[14px]`} style={{ width: '8%' }}>
                              {getCurrencySymbol(currency)}{invoiceResult?.caseStudyPrice || '--'}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td
                            className={`border-l border-r ${isDarkMode ? 'border-white text-white' : 'border-black'} p-1 text-[#0F8491] text-right text-[14px] font-semibold ${isDarkMode ? 'text-white' : ''} ${
                              invoiceResult?.caseStudyPrice === 0 ? `border-t ${isDarkMode ? 'border-white' : 'border-black'}` : ''
                            }`}
                          >
                            Sub Total
                          </td>
                          <td
                            className={`border-r ${isDarkMode ? 'border-white text-white' : 'border-black'} p-1 text-right text-[14px] ${
                              invoiceResult?.caseStudyPrice === 0 ? `border-t ${isDarkMode ? 'border-white' : 'border-black'}` : ''
                            }`}
                            style={{ width: '8%' }}
                          >
                            {getCurrencySymbol(currency)}{(() => {
                              const hasCanceledItems = invoiceResult?.canceledBillItems?.length > 0 || invoiceResult?.currentCanceledBillItems?.length > 0;
                              if (hasCanceledItems) {
                                return invoiceResult?.subTotalAfterCancelation?.toFixed(2);
                              } else {
                                return invoiceResult?.subTotal?.toFixed(2);
                              }
                            })()}
                          </td>
                        </tr>

                        {((isEditMode &&
                          (['Paid', 'Subsidy'].includes(invoiceStatus)
                            ? (discount !== '' && parseFloat(discount) > 0)
                            : !invoiceResult?.modeOfPayment)
                        ) || (!isEditMode &&
                          (['Paid', 'Subsidy'].includes(invoiceStatus)
                            ? (invoiceResult?.discountedPrice > 0)
                            : (invoiceResult?.discountedPrice > 0))
                        )) ? (
                          <tr>
                            <td className={`border-l border-r ${isDarkMode ? 'border-white text-white' : 'border-black'} p-1 text-[#0F8491] text-right text-[14px] font-semibold ${isDarkMode ? 'text-white' : ''}`}>
                              Total Discount
                            </td>
                            <td className={`border-r ${isDarkMode ? 'border-white text-white' : 'border-black'} p-1 text-right text-[14px]`} style={{ width: '8%' }}>
                              {isEditMode ? (
                                <div className="flex items-center justify-end">
                                  <Tooltip content={discountRequest?.isRequested ? `Discount request is ${discountRequest?.details?.status}` : ''} isDisabled={!discountRequest?.isRequested}>
                                    <input
                                      type="text"
                                      value={discount ? `${getCurrencySymbol(currency)}${discount}` : ''}
                                      onChange={(e) => {
                                        const value = e.target.value.replace(`${getCurrencySymbol(currency)}`, '');
                                        setDiscount(value);
                                      }}
                                      placeholder={discountRequest?.isRequested && discountRequest?.details?.status === "Pending" ? `${getCurrencySymbol(currency)} ${discountRequest?.details?.amount}` : "Enter discount"}
                                      className={`w-full text-right p-1 focus:outline-none ${isDarkMode ? 'text-white bg-gray-800' : ''}`}
                                      disabled={discountRequest?.isRequested}
                                      />
                                  </Tooltip>
                                </div>
                              ) : (
                                `${getCurrencySymbol(currency)}${invoiceResult?.discountedPrice || '--'}`
                              )}
                            </td>
                          </tr>
                        ) : null}

                        {invoiceResult?.taxAmount > 0 && (
                          <tr>
                            <td className={`border-l border-r ${isDarkMode ? 'border-white text-white' : 'border-black'} p-1 text-[#0F8491] text-right text-[14px] font-semibold ${isDarkMode ? 'text-white' : ''}`}>
                              {invoiceResult?.taxPercentage ? `Add Tax ${invoiceResult?.taxPercentage}%` : '--'}
                            </td>
                            <td className={`border-r ${isDarkMode ? 'border-white text-white' : 'border-black'} p-1 text-right text-[14px]`} style={{ width: '8%' }}>
                              {getCurrencySymbol(currency)}{invoiceResult?.taxAmount || '--'}
                            </td>
                          </tr>
                        )}
                        <tr className="font-semibold">
                          <td className={`border-l border-t border-r border-b ${isDarkMode ? 'border-white text-white' : 'border-black'} p-2 text-[#0F8491] text-right text-[15px] ${isDarkMode ? 'text-white' : ''}`}>
                            Total Payable
                          </td>
                          <td
                            className={`border-t border-r border-b ${isDarkMode ? 'border-white' : 'border-black'} p-2 text-right text-[15px] bg-[#0F8491] text-white`}
                            style={{ width: '8%' }}
                          >
                            {getCurrencySymbol(currency)}{(() => {
                              const hasDiscount = invoiceResult?.discountedPrice && invoiceResult?.discountedPrice > 0;
                              const hasCanceledItems = invoiceResult?.canceledBillItems?.length > 0 || invoiceResult?.currentCanceledBillItems?.length > 0;
                              if ((hasDiscount && hasCanceledItems) || hasCanceledItems) {
                                return invoiceResult?.totalPriceAfterCancelation?.toFixed(2);
                              } else if (hasDiscount) {
                                return invoiceResult?.totalPriceAfterDiscount?.toFixed(2);
                              } else {
                                return invoiceResult?.totalBill?.toFixed(2);
                              }
                            })()}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  )}

                  {!(invoiceResult?.subTotalAfterCancelation === 0 && invoiceResult?.canceledBillItems?.length > 0) && (
                    <div className="flex justify-end items-center gap-4 mt-4">
                      {isCancelMode ? (
                        <button
                          onClick={handleSaveClick}
                          className={`text-white px-5 py-2 text-[14px] ${selectedItems.length === 0 || (selectedItems.length === 1 && selectedItems[0] === 'urgencyCharges') ? 'opacity-50 cursor-not-allowed' : ''}`}
                          style={{
                            background: '#0F8491',
                            borderRadius: '5px',
                          }}
                          disabled={selectedItems.length === 0 || (selectedItems.length === 1 && selectedItems[0] === 'urgencyCharges')}
                        >
                          Cancel
                        </button>
                      ) : invoiceResult?.orgId?.type === 'government' && invoiceResult?.invoiceStatus !== 'Subsidy' ? (
                          <button
                            onClick={handleSaveOrgClick}
                            className={`text-white px-5 py-2 text-[14px]`}
                            style={{
                              background: '#0F8491',
                              borderRadius: '5px',
                            }}
                          >
                            Save
                          </button>
                      ) : !invoiceResult?.paymentMethod && isEditMode && !invoiceResult?.modeOfPayment && invoiceResult?.invoiceStatus !== 'Subsidy' ? (
                        <>
                          {
                            !checkCanApproveDiscount() &&
                            <Tooltip content={discountRequest?.isRequested ? `Discount request is ${discountRequest?.details?.status}` : ''} isDisabled={!discountRequest?.isRequested}>
                              <button
                                onClick={handleRequestDiscountClick}
                                className={`text-white px-5 py-2 text-[14px] ${!checkRequestBtnDisabled() ? '' : 'opacity-50 cursor-not-allowed'}`}
                                style={{
                                  background: '#0F8491',
                                  borderRadius: '5px',
                                }}
                                disabled={checkRequestBtnDisabled()}
                                >
                                Request For Discount
                              </button>
                            </Tooltip>
                          }
                          <button
                            onClick={handleSaveClick}
                            className={`text-white px-5 py-2 text-[14px] ${(!checkRequestBtnDisabled() || discountRequest?.details?.status === 'Pending') ? 'opacity-50 cursor-not-allowed' : ''}`}
                            style={{
                              background: '#0F8491',
                              borderRadius: '5px',
                            }}
                            disabled={!checkRequestBtnDisabled() || discountRequest?.details?.status === 'Pending'}
                          >
                            Pay Now
                          </button>
                          <button
                            onClick={handlePayBack}
                            className={`text-white px-5 py-2 text-[14px] ${!checkRequestBtnDisabled() ? 'opacity-50 cursor-not-allowed' : ''}`}
                            style={{
                              background: '#0F8491',
                              borderRadius: '5px',
                            }}
                            disabled={!checkRequestBtnDisabled()}
                          >
                            Pay Later
                          </button>
                        </>
                      ) : null}
                    </div>
                  )}
                </>
              );
            })()}

            {((invoiceResult?.canceledBillItems?.length > 0 || tableData?.status === 'Refund (Paid)' ||
              ['Refund', 'Refund (Unpaid)', 'Refund (Paid)'].includes(invoiceResult?.canceledBillDetails?.statusOfBill) || (invoiceResult?.removeUrgencyCharges?.value != null)) &&
              (isCancelMode || isEditMode || !isCopyBillPreview)) && (
              <div className="mt-6">
                <h1 className={`text-[18px] font-bold mt-[30px] mb-[12px] ${isDarkMode ? 'text-white' : ''}`}>
                  Refund Details
                </h1>

                {(() => {
                  let items = [];
                  if ((showRefundDetails || showOnlyRefundDetails) && (!invoiceResult?.canceledBillItems || invoiceResult?.canceledBillItems?.length === 0)) {
                    const refundItems = [];

                    if (invoiceResult?.modality) {
                      refundItems.push({
                        key: 'modality',
                        name: invoiceResult.modality,
                        price: invoiceResult.price || 0,
                        studyRegion: invoiceResult.studyRegion || '',
                        serviceIncluded: [],
                      });
                    }

                    if (invoiceResult?.extraModalities?.length > 0) {
                      invoiceResult.extraModalities.forEach((extra, index) => {
                        refundItems.push({
                          key: 'extraModality',
                          name: extra.modality,
                          price: extra.price || 0,
                          studyRegion: extra.studyRegion || '',
                          serviceIncluded: [],
                        });
                      });
                    }

                    if (invoiceResult?.serviceInvestigation?.length > 0) {
                      invoiceResult.serviceInvestigation.forEach((investigation: string, index: number) => {
                        const prices = invoiceResult?.investigationPrice
                          ? invoiceResult.investigationPrice.split(',').map((price: string) => price.trim())
                          : [];
                        const price = parseFloat(prices[index]) || 0;
                        refundItems.push({
                          key: 'serviceInvestigation',
                          name: investigation,
                          price: price,
                          serviceIncluded: invoiceResult?.selectedServiceIncluded?.filter((service: string) =>
                            (serviceGroups[investigation] || []).includes(service)
                          ) || [],
                        });
                      });
                    }

                    if (refundItems.length > 0) {
                      items.push({
                        items: refundItems,
                        canceledBillDetails: {
                          totalCanceledPrice: invoiceResult?.totalBill || 0,
                          modeOfRefund: invoiceResult?.canceledBillDetails?.modeOfRefund || null,
                          canceledAt: invoiceResult?.canceledBillDetails?.canceledAt,
                          statusOfBill: invoiceResult?.canceledBillDetails?.statusOfBill,
                          reasonOfCancel: invoiceResult?.canceledBillDetails?.reasonOfCancel,
                          includesUrgencyCharges: invoiceResult?.removeUrgencyCharges?.value != null && invoiceResult?.removeUrgencyCharges?.value > 0,
                          urgencyChargesAmount: invoiceResult?.removeUrgencyCharges?.value || 0,
                        },
                      });
                    }
                  } else {
                    let cancellations = (tableData?.status === 'Refund (Paid)'
                      ? invoiceResult?.currentCanceledBillItems || invoiceResult?.canceledBillItems?.flat() || []
                      : invoiceResult?.canceledBillDetails?.statusOfBill === 'Refund (Unpaid)'
                        ? invoiceResult?.currentCanceledBillItems || invoiceResult?.canceledBillItems?.flat() || []
                        : invoiceResult?.canceledBillItems?.flat() || []
                    );

                    cancellations = [...cancellations].sort((a, b) => new Date(b.canceledBillDetails?.canceledAt).getTime() - new Date(a.canceledBillDetails?.canceledAt).getTime());

                    items = cancellations.map((cancellation) => ({
                      items: cancellation.items,
                      canceledBillDetails: {
                          totalCanceledPrice: cancellation.canceledBillDetails?.totalCanceledPrice || 0,
                          modeOfRefund: cancellation.canceledBillDetails?.modeOfRefund || null,
                          canceledAt: cancellation.canceledBillDetails?.canceledAt,
                          statusOfBill: cancellation.canceledBillDetails?.statusOfBill,
                          reasonOfCancel: cancellation.canceledBillDetails?.reasonOfCancel,
                          includesUrgencyCharges: invoiceResult?.removeUrgencyCharges?.value != null && invoiceResult?.removeUrgencyCharges?.value > 0,
                          urgencyChargesAmount: invoiceResult?.removeUrgencyCharges?.value || 0,
                          refundLater: cancellation.canceledBillDetails?.refundLater || false,
                      },
                  }));
                  }

                  return items.map((item, index) => (
                    <div key={index} className={`mb-6 border ${isDarkMode ? 'border-white' : 'border-gray-300'} p-4 rounded-md shadow-sm`}>
                      <div className="flex justify-between items-start">
                        <div>
                          <h2 className={`text-[16px] font-semibold mb-2 ${isDarkMode ? 'text-white' : ''}`}>
                            Refund #{index + 1} : {
                              (() => {
                                const date = new Date(item.canceledBillDetails?.canceledAt);
                                const day = String(date.getDate()).padStart(2, '0');
                                const month = String(date.getMonth() + 1).padStart(2, '0');
                                const year = date.getFullYear();
                                let hours = date.getHours();
                                const minutes = String(date.getMinutes()).padStart(2, '0');
                                const ampm = hours >= 12 ? 'PM' : 'AM';
                                hours = hours % 12 || 12;
                                return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
                              })()
                            }
                          </h2>
                          {item.items.map((subItem, itemIndex) => (
                            <div key={itemIndex} className={`text-[14px] ml-4 mb-2 ${isDarkMode ? 'text-white' : ''}`}>
                              <div className={`${invoiceResult?.appointmentType !== 'consultation' ? 'uppercase' : ''}`}>
                                {invoiceResult?.appointmentType === 'consultation' ? (
                                  <span>
                                    <span className="font-bold">Consultation Service</span>
                                    {(` (${getCurrencySymbol(currency)}${Number(subItem?.price || 0).toFixed(2)})`)}
                                  </span>
                                ) : subItem.key === 'modality' ? (
                                  <>
                                    <span>
                                      <span className="font-bold">{subItem.name} </span>
                                      {(` (${getCurrencySymbol(currency)}${Number(subItem?.price || 0).toFixed(2)})`)}
                                    </span>
                                    {subItem.studyRegion ? ` - ${subItem.studyRegion}` : ''}
                                  </>
                                ) : subItem.key === 'extraModality' ? (
                                  <>
                                    <span>
                                      <span className="font-bold">{subItem.name}</span>
                                      {(` (${getCurrencySymbol(currency)}${Number(subItem?.price || 0).toFixed(2)})`)}
                                    </span>
                                    {subItem.studyRegion ? ` - ${subItem.studyRegion}` : ''}
                                  </>
                                ) : (
                                  <span>
                                    <span className="font-bold">{subItem.name}</span>
                                    {` (${getCurrencySymbol(currency)}${Number(subItem?.price || 0).toFixed(2)})`}
                                  </span>
                                )}
                              </div>
                              <ul className="list-disc pl-4">
                                {subItem?.serviceIncluded && subItem?.serviceIncluded.map((service, serviceIndex) => (
                                  <li key={serviceIndex} className="text-[14px]">- {service}</li>
                                ))}
                              </ul>
                            </div>
                          ))}
                          {(item.items.length > 0) && (
                            <p className={`text-[14px] font-bold ml-4 mb-2 ${isDarkMode ? 'text-white' : ''}`}>
                              Total Refunded: {getCurrencySymbol(currency)}{Number((item.canceledBillDetails?.totalCanceledPrice || 0)).toFixed(2)}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="mt-4 mb-2 flex justify-between items-end gap-4 w-full">
                        <div className="w-2/4">
                          <div className="flex items-center gap-2">
                            <label className={`text-[14px] font-semibold whitespace-nowrap ${isDarkMode ? 'text-white' : ''}`}>
                              Mode of Refund:
                              {(item.canceledBillDetails?.statusOfBill !== 'Refund' && !refundPaymentMethod[index]) && (
                                <span className="text-red-500"> *</span>
                              )}
                            </label>
                            {tableData?.status === 'Refund (Paid)' || (tableData?.status === 'Paid' && isRefundLaterProcessed) ? (
                              <p className={`text-[14px] truncate ${isDarkMode ? 'text-white' : ''}`}>
                                {invoiceResult?.canceledBillDetails?.modeOfRefund
                                  ? invoiceResult.canceledBillDetails.modeOfRefund === 'PayTM'
                                    ? 'PayTM'
                                    : invoiceResult.canceledBillDetails.modeOfRefund.replace(/([a-z])([A-Z])/g, '$1 $2')
                                  : 'N/A'}
                              </p>
                            ) : item.canceledBillDetails?.statusOfBill === 'Refund' ? (
                              <p className={`text-[14px] truncate ${isDarkMode ? 'text-white' : ''}`}>
                                {item.canceledBillDetails?.modeOfRefund
                                  ? item.canceledBillDetails.modeOfRefund === 'PayTM'
                                    ? 'PayTM'
                                    : item.canceledBillDetails.modeOfRefund.replace(/([a-z])([A-Z])/g, '$1 $2')
                                  : 'N/A'}
                              </p>
                            ) : ((tableData?.status === 'Paid' && items[index]?.canceledBillDetails?.refundLater === true) || location.pathname.includes('invoice/preview')) ? (
                              <p className={`text-[14px] truncate ${isDarkMode ? 'text-white' : ''}`}>Refund not processed yet</p>
                            ) : (
                              <select
                                className={`form__select form__select--sm w-1/2 mt-1 ${isDarkMode ? 'text-white bg-gray-800 border-white' : ''}`}
                                id={`prefPaymentMethod-${index}`}
                                name={`prefPaymentMethod-${index}`}
                                style={customStyle.select}
                                value={refundPaymentMethod[index] || ''}
                                onChange={(e) => {
                                  const newMethods = [...refundPaymentMethod];
                                  newMethods[index] = e.target.value;
                                  setRefundPaymentMethod(newMethods);
                                  const newErrors = [...paymentMethodError];
                                  newErrors[index] = '';
                                  setPaymentMethodError(newErrors);
                                }}
                                autoComplete="off"
                              >
                                <option value="">-Select-</option>
                                {paymentMethods?.map((option) => (
                                  <option key={option.value} value={option.value}>
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                            )}
                          </div>
                        </div>
                        {tableData?.status === 'Refund (Paid)' || (tableData?.status === 'Paid' && isRefundLaterProcessed) ||
                        item.canceledBillDetails?.statusOfBill === 'Refund' || location.pathname.includes('invoice/preview') ||
                        (tableData?.status === 'Paid' && items[index]?.canceledBillDetails?.refundLater === true) ? (
                            <></>
                        ) : (
                            <div className="flex gap-2">
                              <button
                                className="bg-[#0F8491] text-white px-4 py-2 text-[14px] rounded"
                                onClick={() => {
                                  if (!refundPaymentMethod[index]) {
                                    const newErrors = [...paymentMethodError];
                                    newErrors[index] = 'Mode of Payment is required';
                                    setPaymentMethodError(newErrors);
                                    return;
                                  }
                                  handleRefundPayment(index);
                                }}
                              >
                                Refund Now
                              </button>
                              <button
                                className="bg-[#0F8491] text-white px-4 py-2 text-[14px] rounded"
                                onClick={() => handleBack(index)}
                              >
                                Refund Later
                              </button>
                            </div>
                          )}
                        </div>
                        {paymentMethodError[index] && item.canceledBillDetails?.statusOfBill !== 'Refund' && (
                          <p className="text-red-500 text-[12px] mt-1">{paymentMethodError[index]}</p>
                        )}
                        {refundPaymentMethod[index] && item.canceledBillDetails?.statusOfBill !== 'Refund' && (
                          <p className={`mt-2 text-[14px] font-semibold ${isDarkMode ? 'text-white' : ''}`}>
                            Selected Refund Mode: {refundPaymentMethod[index].replace(/([a-z])([A-Z])/g, '$1 $2')}
                          </p>
                        )}
                      </div>
                    ));
                })()}
                {invoiceResult?.canceledBillItems?.length > 0 && (
              <div className="text-right mt-4">
                <p className={`text-[16px] font-bold ${isDarkMode ? 'text-white' : ''}`}>
                  Total Refunded: {getCurrencySymbol(currency)}{(() => {
                      let totalRefunded = (!invoiceResult?.hasOwnProperty('modality') || invoiceResult?.modality === "" || invoiceResult?.modality === undefined) && invoiceResult?.extraModalities?.length === 0 && invoiceResult?.serviceInvestigation?.length === 0 ? (invoiceResult?.canceledBillDetails?.totalCanceledPrice || 0) + (invoiceResult?.taxAmount || 0) : (invoiceResult?.canceledBillDetails?.totalCanceledPrice || 0);

                      if (invoiceResult?.removeUrgencyCharges?.value != null && invoiceResult?.removeUrgencyCharges?.value > 0) {
                        totalRefunded += Number(invoiceResult?.removeUrgencyCharges?.value || 0);
                      }

                      if (invoiceResult?.discountedPrice > 0) {
                        totalRefunded -= invoiceResult?.discountedPrice;
                  }

                      return Number(totalRefunded).toFixed(2);
                    })()}
                </p>
                {((!invoiceResult?.hasOwnProperty('modality') || invoiceResult?.modality === "" || invoiceResult?.modality === undefined) &&
                  invoiceResult?.extraModalities?.length === 0 && invoiceResult?.serviceInvestigation?.length === 0 && (invoiceResult?.taxAmount || 0) > 0) && (
                  <p className={`text-[12px] ${isDarkMode ? 'text-white' : 'text-gray-600'}`}>
                    Includes Tax ({invoiceResult?.taxPercentage || 0}%): {getCurrencySymbol(currency)}{Number(invoiceResult?.taxAmount || 0).toFixed(2)}
                  </p>
                )}
                {invoiceResult?.removeUrgencyCharges?.value != null && invoiceResult?.removeUrgencyCharges?.value > 0 && (
                  <p className={`text-[12px] ${isDarkMode ? 'text-white' : 'text-gray-600'}`}>
                    Includes Urgency Charges: {getCurrencySymbol(currency)}{Number(invoiceResult?.removeUrgencyCharges?.value || 0).toFixed(2)}
                      </p>
                    )}
              </div>
              )}
              </div>
            )}
          </section>
          {isCopyBillPreview && (
          <>
            {invoiceResult?.canceledBillItems?.length > 0 && (
              <section className="mt-6">
                <h1 className={`text-[18px] font-bold ${isDarkMode ? 'text-white' : ''}`} style={{ marginTop: "30px", marginBottom: "12px" }}>
                  Refund Details
                </h1>
                <table className={`w-full border-collapse ${isDarkMode ? 'border-white' : 'border-black'}`}>
                  <thead>
                    <tr className="bg-gray-200 text-black">
                      <th className="border-l border-t border-r border-b border-black p-2 text-left">Description</th>
                      <th className="border-t border-r border-b border-black p-2 text-right" style={{ width: "8%" }}>
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceResult.canceledBillItems.flatMap((group: any, groupIndex: number) =>
                      group[0].items.map((item: any, itemIndex: number) => (
                        <tr key={`canceled-${groupIndex}-${itemIndex}`}>
                          <td className={`border-l border-b border-r ${isDarkMode ? 'border-white text-white' : 'border-black'} p-2 text-[14px]`}>
                            {item.key === "modality" ? (
                              <span>
                                <strong>{capitalizeWords(item.name)}</strong>
                                {item.studyRegion ? ` - ${item.studyRegion}` : ""}
                              </span>
                            ) : item.key === "extraModality" ? (
                              <span>
                                <strong>{capitalizeWords(item.name)}</strong>
                                {item.studyRegion ? ` - ${item.studyRegion}` : ""}
                              </span>
                            ) : (
                              <div>
                                <strong>{capitalizeWords(item.name)}</strong>
                                {item.key === "serviceInvestigation" &&
                                  Array.isArray(item.serviceIncluded) &&
                                  item.serviceIncluded.length > 0 && (
                                    <ul className="list-disc pl-4 mt-1">
                                      {item.serviceIncluded.map((service: string, idx: number) => (
                                        <li key={idx} className="text-[14px]">{service}</li>
                                      ))}
                                    </ul>
                                  )}
                              </div>
                            )}
                          </td>
                          <td
                            className={`border-r border-b ${isDarkMode ? 'border-white text-white' : 'border-black'} p-2 text-right text-[14px]`}
                            style={{ width: "8%" }}
                          >
                            {getCurrencySymbol(currency)}{Number(item?.price).toFixed(2)}
                          </td>
                        </tr>
                      ))
                    )}
                    <tr>
                      <td className={`border-l ${isDarkMode ? 'border-white text-white' : 'border-black'} p-1 text-[#0F8491] text-right text-[14px] font-semibold ${isDarkMode ? 'text-white' : ''}`}>
                        Sub Total
                      </td>
                      <td
                        className={`border-l border-r ${isDarkMode ? 'border-white text-white' : 'border-black'} p-1 text-right text-[14px]`}
                        style={{ width: "8%" }}
                      >
                        {getCurrencySymbol(currency)}{invoiceResult?.canceledBillDetails?.totalCanceledPrice?.toFixed(2)}
                      </td>
                    </tr>
                    {invoiceResult?.taxAmount > 0 && (
                      <tr>
                        <td className={`border-l ${isDarkMode ? 'border-white text-white' : 'border-black'} p-1 text-[#0F8491] text-right text-[14px] font-semibold ${isDarkMode ? 'text-white' : ''}`}>
                          {invoiceResult?.taxPercentage ? "Add Tax " + invoiceResult?.taxPercentage + "%" : "--"}
                        </td>
                        <td
                          className={`border-l border-r ${isDarkMode ? 'border-white text-white' : 'border-black'} p-1 text-right text-[14px]`}
                          style={{ width: "8%" }}
                        >
                          {getCurrencySymbol(currency)}{(invoiceResult?.canceledBillDetails?.totalCanceledPrice * (invoiceResult.taxPercentage / 100))?.toFixed(2)}
                        </td>
                      </tr>
                    )}
                    <tr className="font-semibold">
                      <td className={`border-l border-t border-r border-b ${isDarkMode ? 'border-white text-white' : 'border-black'} p-2 text-[#0F8491] text-right text-[15px] ${isDarkMode ? 'text-white' : ''}`}>
                        Total Refund Amount
                      </td>
                      <td
                        className={`border-r border-t border-b ${isDarkMode ? 'border-white' : 'border-black'} p-2 text-right text-[15px] bg-[#0F8491] text-white`}
                        style={{ width: "8%" }}
                      >
                        {getCurrencySymbol(currency)}{(invoiceResult?.canceledBillDetails?.totalCanceledPrice * (1 + invoiceResult.taxPercentage / 100))?.toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>
                {invoiceResult?.canceledBillDetails?.statusOfBill === 'Refund' && (
                  <div className="flex justify-between items-center mt-2">
                    <div className="items-center gap-2">
                      <p className={`text-[14px] font-semibold ${isDarkMode ? 'text-white' : ''}`}>
                        Mode of Refund:{' '}
                        {invoiceResult?.canceledBillDetails?.modeOfRefund === 'PayTM'
                          ? 'PayTM'
                          : invoiceResult?.canceledBillDetails?.modeOfRefund?.replace(/([a-z])([A-Z])/g, '$1 $2') || 'N/A'}
                      </p>
                    </div>
                  </div>
                )}
              </section>
            )}
            {showInvoiceCopyDetails && (
              <section className="mt-6">
                <h1 className="text-[18px] font-bold" style={{ marginTop: "30px", marginBottom: "12px" }}>
                  Refund Details
                </h1>
                <table className="w-full border-collapse border border-black">
                  <thead>
                    <tr className="bg-gray-200 text-black">
                      <th className="border-l border-t border-r border-b border-black p-2 text-left">Description</th>
                      <th className="border-t border-r border-b border-black p-2 text-right" style={{ width: "8%" }}>
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr key="modality">
                      <td className="border-l border-b border-r border-black p-2 text-[14px]">
                        <span>
                          <strong>{capitalizeWords(invoiceResult?.modality)}</strong>
                          {invoiceResult?.studyRegion ? ` - ${invoiceResult.studyRegion}` : ""}
                        </span>
                      </td>
                      <td
                        className="border-r border-b border-black p-2 text-right text-[14px]"
                        style={{ width: "8%" }}
                      >
                        {getCurrencySymbol(invoiceResult?.generalSettings?.currency)}
                        {Number(invoiceResult?.price).toFixed(2)}
                      </td>
                    </tr>
                    {invoiceResult?.extraModalities?.length > 0 &&
                    invoiceResult.extraModalities.map((extra, index) => (
                      <tr key={`extraModality-${index}`}>
                        <td className="border-l border-b border-r border-black p-2 text-[14px]">
                          <span>
                            <strong>{capitalizeWords(extra?.modality)}</strong>
                            {extra?.studyRegion ? ` - ${extra.studyRegion}` : ""}
                          </span>
                        </td>
                        <td
                          className="border-r border-b border-black p-2 text-right text-[14px]"
                          style={{ width: "8%" }}
                        >
                          {getCurrencySymbol(invoiceResult?.generalSettings?.currency)}
                          {Number(extra?.price || 0).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                    {invoiceResult?.serviceInvestigation?.map((service, index) => (
                      <tr key={`service-${index}`}>
                        <td className="border-l border-b border-r border-black p-2 text-[14px]">
                          <div>
                            <strong>{capitalizeWords(service)}</strong>
                            {invoiceResult?.selectedServiceIncluded?.length > 0 && (
                              <ul className="list-disc pl-4 mt-1">
                                {invoiceResult.selectedServiceIncluded.map((includedService, idx) => (
                                  <li key={idx} className="text-[14px]">{includedService}</li>
                                ))}
                              </ul>
                            )}
                          </div>
                        </td>
                        <td
                          className="border-r border-b border-black p-2 text-right text-[14px]"
                          style={{ width: "8%" }}
                        >
                          {getCurrencySymbol(invoiceResult?.generalSettings?.currency)}
                          {Number(invoiceResult?.investigationPrice.split(", ")[index]).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                    {/* Sub Total */}
                    <tr>
                      <td className="border-l border-black p-1 text-[#0F8491] text-right text-[14px] font-semibold">
                        Sub Total
                      </td>
                      <td
                        className="border-l border-r border-black p-1 text-right text-[14px]"
                        style={{ width: "8%" }}
                      >
                        {getCurrencySymbol(invoiceResult?.generalSettings?.currency)}
                        {invoiceResult?.subTotalAfterCancelation?.toFixed(2)}
                      </td>
                    </tr>
                    {/* Tax */}
                    {invoiceResult?.taxAmount > 0 && (
                      <tr>
                        <td className="border-l border-black p-1 text-[#0F8491] text-right text-[14px] font-semibold">
                          {invoiceResult?.taxPercentage ? `Add Tax ${invoiceResult.taxPercentage}%` : "--"}
                        </td>
                        <td
                          className="border-l border-r border-black p-1 text-right text-[14px]"
                          style={{ width: "8%" }}
                        >
                          {getCurrencySymbol(invoiceResult?.generalSettings?.currency)}
                          {invoiceResult?.taxAmount?.toFixed(2)}
                        </td>
                      </tr>
                    )}
                    {/* Total Refund Amount */}
                    <tr className="font-semibold">
                      <td className="border-l border-t border-r border-b border-black p-2 text-[#0F8491] text-right text-[15px]">
                        Total Refund Amount
                      </td>
                      <td
                        className="border-r border-t border-b border-black p-2 text-right text-[15px] bg-[#0F8491] text-white"
                        style={{ width: "8%" }}
                      >
                        {getCurrencySymbol(invoiceResult?.generalSettings?.currency)}
                        {invoiceResult?.totalPriceAfterCancelation?.toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>
                {invoiceResult?.canceledBillDetails?.statusOfBill === 'Cancelled' && (
                  <div className="flex justify-between items-center mt-2">
                    <div className="items-center gap-2">
                      <p className="text-[14px] font-semibold">
                        Mode of Refund:{' '}
                        {invoiceResult?.canceledBillDetails?.modeOfRefund
                          ? invoiceResult.canceledBillDetails.modeOfRefund.replace(/([a-z])([A-Z])/g, '$1 $2')
                          : 'Refund not processed yet.'}
                      </p>
                    </div>
                  </div>
                )}
              </section>
            )}
          </>
          )}
          <section className='mb-4'>
            <div className='border-t-2 border-[#000] pt-4 mt-2 mb-4' style={isDarkMode ? { marginTop: '60px', color: '#ffffff' } : { marginTop: '60px', color: '#49475A' }}>
              <div className='flex justify-between'>
                <p>
                  <strong>Note: </strong>
                  {isEditMode ? (
                    <span
                      contentEditable={true}
                      onBlur={handleNoteChange}
                      suppressContentEditableWarning={true}
                      style={{ outline: 'none' }}
                    >
                      {invoiceResult?.note ? invoiceResult.note : note}
                    </span>
                  ) : (
                    <span>{invoiceResult?.note ? invoiceResult.note : note}</span>
                  )}
                </p>
                <p>
                  <strong>Prepared By:</strong>{' '}
                  {localStorage.getItem('name') || sessionStorage.getItem('name') || '--'}
                </p>
              </div>
            </div>
          </section>

          <section className='bg-[#0F8491] p-2'>
            <div className='flex flex-row justify-between items-center border-t-2 border-[#0F8491] mt-2'>
              {(result?.hospitalDetail?.hospitalFooter?.contactNumber || result?.hospitalDetail?.contactNumber) && (
                <div className='flex flex-row gap-2 items-center'>
                  <img src={phoneIconWhite} alt="" />
                  <p className='text-[14px] font-normal text-white'>
                    {result?.hospitalDetail?.hospitalFooter?.contactNumberCountryCode || result?.hospitalDetail?.contactNumberCountryCode}{' '}
                    {result?.hospitalDetail?.hospitalFooter?.contactNumber || result?.hospitalDetail?.contactNumber}
                  </p>
                </div>
              )}

              {(result?.hospitalDetail?.hospitalFooter?.email || result?.hospitalDetail?.hospitalEmailId) && (
                <div className='flex flex-row gap-2 items-center'>
                  <img src={mailIconwhite} alt="" />
                  <p className='text-[14px] font-normal text-white'>
                    {result?.hospitalDetail?.hospitalFooter?.email || result?.hospitalDetail?.hospitalEmailId}
                  </p>
                </div>
              )}

              <div className='flex flex-row gap-2 items-center'>
                <img src={mapIconWhite} alt="" />
                <p className='text-[14px] font-normal text-white'>
                  {result?.hospitalDetail?.hospitalHeader?.address
                    ? `${result?.hospitalDetail?.hospitalHeader?.address} ${result?.hospitalDetail?.hospitalHeader?.state} ${result?.hospitalDetail?.hospitalHeader?.city} ${result?.hospitalDetail?.hospitalHeader?.zipCode}`
                    : `${result?.hospitalDetail?.address} ${result?.hospitalDetail?.state} ${result?.hospitalDetail?.city} ${result?.hospitalDetail?.zipCode}`}
                </p>
              </div>
            </div>
          </section>
        </div>
        <div className="watermark-text">
          <Icon name="appointmentPreview" className="w-[100%] h-[100%]" alt="appointmentPreview" />
        </div>
      </div>

      <ConfirmationPopup
        isOpen={isPopupOpen}
        title={confirmationPopup.title}
        message={
          <div>
            <p>{confirmationPopup.message}</p>
            <div className="mt-4">
              <div className='flex gap-4'>
                <label className="text-[14px] font-semibold">Reason:<span className="required-asterisk">*</span></label>
                {errorMessage && (
                  <p className="text-red-500 text-[13px]">{errorMessage}</p>
                )}
              </div>
              <div className="mt-2">
                {cancellationReasons.map((reasonOption, index) => (
                  <div key={index} className="flex items-center mb-2">
                    <input
                      type="radio"
                      id={`reason-${index}`}
                      name="cancellation-reason"
                      value={reasonOption}
                      checked={reason === reasonOption}
                      onChange={(e) => {
                        const value = e.target.value;
                        setReason(value);
                        setErrorMessage('');
                      }}
                      className="mr-2"
                      required
                    />
                    <label htmlFor={`reason-${index}`} className="text-[14px]">
                      {reasonOption}
                    </label>
                  </div>
                ))}
                <div className="mt-2">
                  <input
                    type="text"
                    value={customReason}
                    onChange={(e) => setCustomReason(e.target.value)}
                    placeholder="Enter reason (optional)"
                    className={`w-full p-2 border border-gray-300 rounded ${isDarkMode ? 'text-black' : 'text-gray-900'}`}
                  />
                </div>
              </div>
            </div>
          </div>
        }
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
      />

      <ConfirmationPopup
        isOpen={isOrgPopupOpen}
        title={orgConfirmationPopup.title}
        message={orgConfirmationPopup.message}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
      />

      <ConfirmationPopup
        isOpen={isPaymentPopupOpen}
        title="Make Payment"
        message={
          <div>
            <div className="mt-4">
              <select
                className="form__select form__select--sm w-full mt-2 p-2 border border-gray-300 rounded"
                value={selectedPaymentMethod}
                onChange={handlePaymentMethodChange}
                autoComplete="off"
              >
                <option value="">-Select-</option>
                {paymentMethods?.map((option: any) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        }
        onConfirm={handleMakePayment}
        onCancel={handlePaymentPopupClose}
      />

      <SuccessModal
        isSuccessModalOpen={isSuccessModalOpen}
        title={displayMessage}
        handleCloseModal={handleSuccessMessage}
      />
      <Loader isLoaderOpen={loading || invoiceLoading || editLoading || isDownloading} />
    </div>
  );
}
